import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { hideDialog } from '../../../store/dialog/dialog.actions';
import AlertPopup from '@aib/uikit-react/dist/Content/AlertPopup/AlertPopup';
import dialogConfigFactory from './dialogConfigFactory';
import langCommon from '~/shared/lang.common.json';

const lang = {
  FILESIZE_BIG: 'Your file is too big.',
  ERROR_TRY_SMALL_FILE: 'Make sure your file is under 10MB and try again.',
};

interface Props {
  oversizeFiles: Array<{ name: string }>;
  hideDialog: (...args: unknown[]) => unknown;
}

function DocUploadFilesTooBigDialog({ oversizeFiles, hideDialog }: Props) {
  const [visible, setVisible] = useState(false);
  const strFileList = oversizeFiles.map((file) => file.name).join('\n');
  const content = lang.ERROR_TRY_SMALL_FILE + '\n\n' + strFileList;
  const dialogConfig = dialogConfigFactory({
    heading: lang.FILESIZE_BIG,
    content,
    accept: langCommon.OK,
  });

  useEffect(() => {
    let timeoutId;
    timeoutId = setTimeout(() => setVisible(true), 0);

    return () => {
      timeoutId = clearInterval(timeoutId);
    };
  });

  return (
    <AlertPopup
      id="DocumentUploadDialog"
      title={dialogConfig.heading}
      confirmLabel={dialogConfig.accept}
      cancelLabel=""
      isOpen={visible}
      onCancel={hideDialog}
      onConfirm={hideDialog}
    >
      {dialogConfig.content}
    </AlertPopup>
  );
}

const mapStateToProps = (state, ownProps) => ({
  oversizeFiles: ownProps.oversizeFiles,
});

const mapDispatchToProps = {
  hideDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocUploadFilesTooBigDialog);
